import { defineComponent as B, computed as o, useId as E, createBlock as u, openBlock as m, unref as p, normalizeClass as s, withCtx as f, createElementVNode as n, createVNode as R, mergeProps as w, createCommentVNode as U, toDisplayString as r, resolveDynamicComponent as C, createTextVNode as g } from "vue";
import { RevButton as V } from "@ds/components/Button";
import { RevButtonCard as K } from "@ds/components/ButtonCard";
import { RevIllustration as P } from "@ds/components/Illustration";
import { isEmpty as j } from "../../utils/isEmpty.js";
import { tw as t } from "../../utils/tailwind.js";
const D = { class: "w-full" }, J = /* @__PURE__ */ B({
  name: "RevEditorialCard",
  __name: "EditorialCard",
  props: {
    alt: { default: "" },
    content: { default: "" },
    cta: { default: "" },
    image: {},
    imageProps: { default: () => ({ height: 164, width: 258 }) },
    titleKicker: { default: "" },
    title: {},
    titleTag: {},
    to: {},
    variant: { default: "default" }
  },
  setup(a) {
    const l = a, b = o(() => [{
      default: t`md:w-256`,
      full: t`md:w-full`
    }[l.variant]]), y = o(() => {
      const e = [
        t`shadow-short rounded-lg relative flex cursor-pointer overflow-hidden hover:shadow-long`,
        t`motion-safe:transition motion-safe:duration-300 motion-safe:ease-in`
      ], i = {
        default: t`h-[376px] flex-col`,
        full: t`h-[376px] flex-col md:h-[133px] md:flex-row`
      };
      return [e, i[l.variant]];
    }), N = o(() => {
      const e = "object-cover", i = {
        default: t`!h-[168px] w-full`,
        full: t`!h-[168px] w-full md:!h-auto md:w-[250px]`
      };
      return [e, i[l.variant]];
    }), k = o(() => {
      const e = t`bg-float-default-low flex flex-1 justify-between p-24 hover:bg-float-default-low-hover motion-safe:duration-300 motion-safe:ease-in`, i = {
        default: t`flex-col items-start`,
        full: t`grow flex-col items-start md:flex-row md:items-center`
      };
      return [e, i[l.variant]];
    }), T = o(() => [{
      default: t`line-clamp-2`,
      full: t`line-clamp-1`
    }[l.variant], t`text-static-default-hi body-1-bold`]), $ = o(() => [{
      default: t`line-clamp-3`,
      full: t`line-clamp-2 md:line-clamp-3`
    }[l.variant]]), I = o(() => ({
      default: t`text-action-default-hi body-2-link mt-8 hover:text-action-default-hi-hover motion-safe:transition-colors`,
      full: t`md:ml-32 md:max-w-[212px]`
    })[l.variant]), v = o(() => {
      switch (l.variant) {
        case "full":
          return {
            props: {
              variant: "secondary"
            },
            tag: V
          };
        default:
          return { tag: "span" };
      }
    }), q = o(() => !j(l.cta)), c = E(), d = `title-${c}`, h = `title-kicker-${c}`, x = `cta-${c}`;
    return (e, i) => (m(), u(p(K), {
      "aria-labelledby": `${h} ${d}`,
      class: s(b.value),
      to: a.to
    }, {
      default: f(() => [
        n("article", {
          class: s(y.value)
        }, [
          R(p(P), w(a.imageProps, {
            alt: a.alt,
            class: N.value,
            src: a.image
          }), null, 16, ["alt", "class", "src"]),
          n("div", {
            class: s(k.value)
          }, [
            n("div", D, [
              n("div", {
                id: h,
                class: "text-static-default-low caption"
              }, r(a.titleKicker), 1),
              (m(), u(C(a.titleTag), {
                id: d,
                class: s(T.value)
              }, {
                default: f(() => [
                  g(r(a.title), 1)
                ]),
                _: 1
              }, 8, ["class"])),
              n("p", {
                class: s(["text-static-default-mid body-2 mt-8", $.value])
              }, r(a.content), 3)
            ]),
            q.value ? (m(), u(C(v.value.tag), w({
              key: 0,
              id: x
            }, v.value.props, {
              "aria-labelledby": `${d} ${x}`,
              class: I.value,
              role: "link",
              tabindex: "0"
            }), {
              default: f(() => [
                g(r(a.cta), 1)
              ]),
              _: 1
            }, 16, ["aria-labelledby", "class"])) : U("", !0)
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["aria-labelledby", "class", "to"]));
  }
});
export {
  J as default
};
